import Swiper from "swiper";
import { A11y, Autoplay } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
    const careersSwiper = document.querySelector(".careers__swiper");
    if (careersSwiper) {
        new Swiper(careersSwiper, {
            slidesPerView: 1.05,
            spaceBetween: 16,
            autoplay: {
                delay: 6000,
            },
            speed: 1000,
            loop: true,
            modules: [Autoplay, A11y],
            breakpoints: {
                1280: {
                    slidesPerView: 1,
                },
            },
        });
    }
});
